import { Link } from "react-router-dom";
import { Clock, Lock, CreditCard } from "lucide-react";
import { useBillingStatus } from "@/hooks/useBillingStatus";

export function BillingBanner() {
  const { access, visible, locked, hideLink } = useBillingStatus();
  if (!visible) return null;

  return (
    <div className={`px-4 sm:px-8 py-2 text-sm flex items-center justify-between gap-3 flex-wrap ${locked ? "bg-stone-900 text-white" : "bg-amber-100 text-amber-900"}`} data-testid="billing-banner">
      <div className="inline-flex items-center gap-2">
        {locked ? <Lock className="w-4 h-4" /> : <Clock className="w-4 h-4" />}
        <span data-testid="billing-banner-message">{access.message}</span>
      </div>
      {!hideLink && (
        <Link to="/billing" data-testid="billing-banner-link" className={`inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full ${locked ? "bg-amber-500 text-stone-900 hover:bg-amber-400" : "bg-stone-900 text-white hover:bg-amber-700"}`}>
          <CreditCard className="w-3.5 h-3.5" /> {locked ? "Choose a plan" : "See plans"}
        </Link>
      )}
    </div>
  );
}
